import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=04354cc8&scoped=true&"
import script from "./TemplateList.vue?vue&type=script&lang=ts&"
export * from "./TemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=04354cc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04354cc8",
  null
  
)

export default component.exports